import { useEffect, useState } from 'react';
import useCommonStore from './useCommonStore';
import { useDetectDevice } from './useDetectDevice';

export function useCameraCheck() {
  const { setLoading } = useCommonStore();
  const { isDesktop } = useDetectDevice();

  const [checkAllowTakePhoto, setCheckAllowTakePhoto] = useState(false);

  useEffect(() => {
    if (isDesktop) return;
    setLoading(true);
    if ('mediaDevices' in navigator) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(function (stream) {
          if (stream.getVideoTracks().length > 0) {
            setCheckAllowTakePhoto(true);
          } else {
            setCheckAllowTakePhoto(false);
          }
          setLoading(false);
        })
        .catch(function (error) {
          console.error(
            `🔥 useCameraCheck ❌ useEffect ➡️ ERROR ↩`,
            error?.message
          );
          setCheckAllowTakePhoto(false);
          setLoading(false);
        });
    }
  }, []);

  return {
    checkAllowTakePhoto,
  };
}
